var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Gmail",
    role: "img",
    viewBox: "0 0 512 512",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "none",
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    d: "M120 392V151.075h272V392"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.05,
    d: "M256 285L120 392l-4-212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 392H97c-12 0-22-10-22-23V143h45z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.08,
    d: "M317 392h77V159H82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M97 121h318L256 234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 392h23c12 0 22-10 22-23V143h-45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 44,
    d: "M97 143l159 115 159-115"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.565844842501f5042c5f93f674d0eaff.svg";
export { ForwardRef as ReactComponent };